import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem, RequirementContextType } from "../../../../types";
import { WSPillProps } from "@wingspanhq/fe-component-library";
import {
  BackgroundCheckRequestStatus,
  IBackgroundCheckRequestResponse
} from "@wingspanhq/background-checks/dist/lib/interfaces";
import { extendRequirementStatusSecondaryText } from "../../../../helpers/extendRequirementStatusSecondaryText";
import { extendRequirementStatusPill } from "../../../../helpers/extendRequirementStatusPill";

export const getBackgroundCheckRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  backgroundChecksRequest: IBackgroundCheckRequestResponse | undefined,
  contextType: RequirementContextType
): { pill: WSPillProps; secondaryText?: string } => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  if (
    backgroundChecksRequest?.status === BackgroundCheckRequestStatus.Success
  ) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };
  } else if (
    backgroundChecksRequest?.status === BackgroundCheckRequestStatus.New ||
    backgroundChecksRequest?.status === BackgroundCheckRequestStatus.Pending
  ) {
    if (contextType === RequirementContextType.Payee) {
      pill = {
        theme: "neutral",
        text: "Awaiting contractor",
        icon: "time"
      };
      secondaryText = "Awaiting contractor completion";
    } else {
      if (
        backgroundChecksRequest?.status === BackgroundCheckRequestStatus.Pending
      ) {
        pill = {
          theme: "warning",
          text: "Action required",
          icon: true
        };
        secondaryText = "Awaiting your completion";
      } else {
        pill = {
          theme: "neutral",
          text: "Processing",
          icon: "time"
        };
      }
    }
  } else if (
    backgroundChecksRequest?.status === BackgroundCheckRequestStatus.Processing
  ) {
    pill = {
      theme: "neutral",
      text: "Processing",
      icon: "time"
    };
    secondaryText = "Awaiting results";
  } else {
    pill = {
      theme: "error",
      text: "Failed",
      icon: true
    };
    secondaryText = backgroundChecksRequest?.statusMessage;
  }

  return {
    pill: extendRequirementStatusPill(requirement, contextType, pill),
    secondaryText: extendRequirementStatusSecondaryText(
      requirement,
      contextType,
      secondaryText
    )
  };
};
